module.exports = __webpack_public_path__ + "static/heretics-of-dune-c9034f4584a4488c49c91210c9907657.jpg";